import Sizes from '@chakra-ui/theme';

function getSize(size) {
  var themeSize = Sizes[size];
  return {
    container: {
      width: size,
      height: size,
      fontSize: "calc(" + (themeSize != null ? themeSize : size) + " / 2.5)"
    },
    excessLabel: {
      width: size,
      height: size
    },
    label: {
      fontSize: "calc(" + (themeSize != null ? themeSize : size) + " / 2.5)",
      lineHeight: size !== '100%' ? themeSize != null ? themeSize : size : undefined
    }
  };
}

var sizes = {
  '2xs': getSize('4'),
  xs: getSize('6'),
  sm: getSize('8'),
  md: getSize('10'),
  lg: getSize('16'),
  xl: getSize('24'),
  '2xl': getSize('32'),
  full: getSize('100%')
};
export default {
  sizes
};
//# sourceMappingURL=Avatar.js.map